import { useState, useEffect, useRef } from 'react';
import useRefMounted from 'src/hooks/useRefMounted';
import {
  Grid,
  Card,
  Divider,
  Typography,
  Box,
  Container,
  useTheme,
  useMediaQuery
} from '@mui/material';
import Logo from 'src/components/LogoSign';

const AppointmentError = (props) => {
  const theme = useTheme();
  // const isMountedRef = useRefMounted();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Grid container spacing={0} justifyContent="center">
      <Grid item xs={12}>
        <Card variant="outlined" sx={{ m: mobile ? 0 : 3, p: 2 }}>
          <Container maxWidth="md">
            <Logo />
            <Box textAlign="center" mb={3}>
              <Container maxWidth="xs">
                <Typography
                  variant="h1"
                  sx={{
                    mt: 4,
                    mb: 2
                  }}
                >
                  {'Sorry! Something went wrong.'}
                </Typography>
                <Typography
                  variant="h4"
                  color="text.secondary"
                  fontWeight="normal"
                  sx={{
                    mb: 4
                  }}
                >
                  {
                    'We could not process your booking at this time. Please call or email us to book your appointment instead.'
                  }
                </Typography>
              </Container>
              <img
                alt="Appointment Confirmation"
                height={300}
                src="/static/images/appointments/appointment-booking-error.jpg"
              />
            </Box>

            {/* <Box display="flex" justifyContent="center">
              <a
                href="https://gethelm.io/"
                target="_blank"
                rel="noopener"
              >
                {'Powered by Helm'}
              </a>
            </Box> */}

            <Container maxWidth="sm">
              <Box
                sx={{
                  textAlign: 'center',
                  p: 3
                }}
              >
                {/* <FormControl variant="outlined" fullWidth>
                <FormHelperText>
                  {t('Need help? Contact us at 612345678 or clinic@clinic.com')}
                </FormHelperText>
              </FormControl> */}
                <Divider
                  sx={{
                    mt: 3
                  }}
                />
              </Box>
            </Container>
          </Container>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
          <a href="https://gethelm.io/" target="_blank" rel="noopener">
            {'Powered by Helm'}
          </a>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AppointmentError;
